import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";

const ProductCard = ({ product, handleAddToCart }) => {
  //console.log(product)
  return (
    <Card className="card">
      <CardMedia
        component="img"
        height="250"
        image={product.image}
        alt={product._id}
      />
      <CardContent>
      <Typography
          color="textPrimary"
          component="div"
          gutterBottom
          variant="h6"
          align="left"
        >
          {product.name}
        </Typography>
      <Typography
          component="div"
          gutterBottom
          variant="h6"
          align="left"
        ><p className="text">${product.cost}</p>
          
        </Typography>
        <Rating name="read-only" value={product.rating} readOnly />
      </CardContent>
      <CardActions className="card-actions">
      <Button variant="contained" className="card-button" onClick={handleAddToCart}>
            <AddShoppingCartOutlined/> 
              ADD TO CART
          </Button>
      </CardActions>
    </Card>
  );
};

export default ProductCard;
